import CryptoJS from "crypto-js";

const CRYPTO = {
  AES_KEY: CryptoJS.enc.Utf8.parse("oSOhgvKFi2AbgyVwtKMKwFV8pSc5kyxU"),
  AES_IV:  CryptoJS.enc.Utf8.parse("oSOhgvKFi2AbgyVw"),
};

export default CRYPTO;